const errorFile = (errors) => {
  const errorFileContent = errors.join("\n");
  const errorBlob = new Blob([errorFileContent], { type: "text/plain" });
  const errorFileUrl = URL.createObjectURL(errorBlob);

  const downloadLink = document.createElement("a");
  downloadLink.href = errorFileUrl;
  downloadLink.download = "error.txt";
  downloadLink.click();

  URL.revokeObjectURL(errorFileUrl);
  return "Please resolve errors mentioned in error.txt file";
};

const validateCSV = (validationType, csvContent) => {
  var validationStatus = "validated";
  const lines = csvContent.split("\n").map((val) => val.trim());
  const csvHeaders =
    lines.length > 0 ? lines[0].split(",").map((val) => val.trim()) : [];
  switch (validationType) {
    case "BulkUploadCarrierChange":
      validationStatus = validateForBulkUploadCarrierChange(lines, csvHeaders);
      break;

    case "BulkUploadDriverSecondaryLocality":
      validationStatus = validateForBulkUploadDriverSecondaryLocality(lines, csvHeaders);
      break;

    case "BulkUploadDriverPolygonId":
      validationStatus = validateForBulkUploadDriverPolygonId(lines, csvHeaders);
      break;

    case "BulkCreatePolygon":
      validationStatus = validateForBulkCreatePolygon(lines, csvHeaders);
      break;

    case "BulkUpdatePolygon":
      validationStatus = validateForBulkUpdatePolygon(lines, csvHeaders);
      break;

    case "DriverNotification":
      validationStatus = validateForDriverNotification(lines, csvHeaders);
      break;

    case "DriverNotificationOB":
      validationStatus = validateForDriverNotificationOB(lines, csvHeaders);
      break;

    case "DriverStories":
      validationStatus = validateForDriverStories(lines, csvHeaders);
      break;

    case "CommunicationHub":
      validationStatus = validateForCommunicationHub(lines, csvHeaders);
      break;

    case "FleetCoachTask":
      validationStatus = validateForFleetCoachTask(lines, csvHeaders);
      break;

    case "DriverProperties:first_responder_training":
      validationStatus = validateForDriverProperties(lines, csvHeaders, "first_responder_training");
      break;

    case "DriverProperties:hearing_and_speech_impaired":
      validationStatus = validateForDriverProperties(lines, csvHeaders, "hearing_and_speech_impaired");
      break;

    case "DriverProperties:rider_helmet_address":
      validationStatus = validateForDriverProperties(lines, csvHeaders, "rider_helmet_address");
      break;
    case "DriverProperties:differently_abled":
      validationStatus = validateForDriverProperties(lines, csvHeaders, "differently_abled");
      break;
    case "BulkUploadBonuses":
      validationStatus = validateForBulkUploadBonuses(lines, csvHeaders);
      break;

    case "BulkUploadObTags":
      validationStatus = validateForBulkUploadObTags(lines, csvHeaders);
      break;

    case "BulkRevertDisputes":
      validationStatus = validateForBulkRevertDisputes(lines, csvHeaders);
      break;

    case "BulkUploadIncentiveMultipliers":
      validationStatus = validateBulkUploadIncentiveMultipliers(lines, csvHeaders);
      break;
  }
  return { validationStatus, csvHeaders };
};

const validateForBulkRevertDisputes = (lines, headers) => {
  const errors = [];
  if (lines.length < 2) {
    errors.push("Error: Empty CSV file");
  }
  if (lines.length > 200) {
    errors.push("Error: Number of rows should not exceed 200");
  }
  if (lines.length > 1) {
    if (headers.length != 2 || headers[0] != "dispute_id" || headers[1] != "reason") {
      errors.push("Error: Verify headers with sample file");
    }
  }
  if (errors.length == 0) {
    const values = lines.map((line) => line.split(","));
    for (let i = 1; i < values.length; i++) {
      if (values[i][0].length == 0 || values[i][1].length == 0) {
        errors.push(`Error: Line ${i + 1} has empty cells`);
      }
    }
  }
  if (errors.length > 0) {
    return errorFile(errors);
  }
  return "validated";
}

const validateForBulkUploadBonuses = (lines, headers) => {
  if (headers.length < 3 || headers[0] != "driver_id" || headers[1] != "bonus_name" || headers[2] != "action") {
    return errorFile(["Error: Verify headers with sample file"])
  }
  return "validated";
}

const validateForBulkUploadObTags = (lines, headers) => {
  const errors = [];

  if (lines.length == 0 || lines.length == 1) {
    errors.push(`Error: Empty CSV file`);
  }

  if (lines.length > 10000) {
    errors.push(`Error: "Number of rows should not exceed 50000`);
  }

  if (headers.length < 5 || headers[0] != "ob_id" || headers[1] != "tag_name" || headers[2] != "tag_type" || headers[3] != "start_time" || headers[4] != "end_time") {
    errors.push(`Error: Verify headers with sample file`)
  }

  if (errors.length > 0) {
    return errorFile(errors);
  }

  return "validated";
}

const validateForBulkUploadCarrierChange = (lines, headers) => {
  const errors = [];

  // validate number of columns
  if (headers.length != 2) {
    errors.push(`Error: Verify headers with sample file`);
  } else {
    if (!(headers[0] == "feid" && headers[1] == "carrier_id")) {
      errors.push(`Error: Verify header names with sample file`);
    }
  }

  if (lines.length > 50000) {
    errors.push(`Error: "Number of rows should not exceed 50000`);
  }

  if (errors.length > 0) {
    return errorFile(errors);
  }
  return "validated";
};

const validateForBulkUploadDriverSecondaryLocality = (lines, headers) => {
  const errors = [];

  // validate number of columns
  if (headers.length !== 2) {
    errors.push("Error: Verify headers with sample file");
  } else {
    if (!(headers[0] === "driver_id" && headers[1] === "secondary_locality_id")) {
      errors.push("Error: Verify header names with sample file");
    }
  }

  if (lines.length > 10000) {
    errors.push("Error: Number of rows should not exceed 10000");
  }

  if (errors.length > 0) {
    return errorFile(errors);
  }

  return "validated";
};

const validateForBulkUploadDriverPolygonId = (lines, headers) => {
  const errors = [];

  // validate number of columns
  if (headers.length !== 3) {
    errors.push("Error: Verify headers with sample file");
  } else {
    if (!(headers[0] === "driver_id" && headers[1] === "polygon_id" && headers[2] === "action")) {
      errors.push("Error: Verify header names with sample file");
    }
  }

  if (lines.length > 10000) {
    errors.push("Error: Number of rows should not exceed 10000");
  }

  if (errors.length > 0) {
    return errorFile(errors);
  }

  return "validated";
};

const validateBulkUploadIncentiveMultipliers = (lines, headers) => {
  const errors = [];

  const expectedHeaders = [
    "city_code",
    "rule_config_id",
    "date",
    "zone_id",
    "locality_id",
    "carrier_id",
    "tag",
    "slot_name",
    "entity_type",
    "entity_id",
    "incentive_multiplier",
  ]

  if (headers.length !== expectedHeaders.length) {
    errors.push("Error: Verify headers with sample file");
  } else {
    for (let i = 0; i < headers.length; i++) {
      if (headers[i] !== expectedHeaders[i]) {
        errors.push(`Error: Header mismatch at column ${i + 1}. Expected "${expectedHeaders[i]}", found "${headers[i]}"`);
      }
    }
  }

  if (lines.length > 10000) {
    errors.push("Error: Number of rows should not exceed 10000");
  }

  if (errors.length > 0) {
    return errorFile(errors);
  }

  return "validated";
}

const validateForBulkCreatePolygon = (lines, headers) => {
  const errors = [];

  const expectedHeaders = [
    "polygon_name",
    "polygon_type",
    "city_id",
    "zone_id",
    "centroid",
    "ref_id",
    "is_active",
    "boundary"
  ];

  // validate number of columns
  if (headers.length !== expectedHeaders.length) {
    errors.push("Error: Verify headers with sample file");
  } else {
    //validate headers names
    for (let i = 0; i < headers.length; i++) {
      if (headers[i] !== expectedHeaders[i]) {
        errors.push(`Error: Header mismatch at column ${i + 1}. Expected "${expectedHeaders[i]}", found "${headers[i]}"`);
      }
    }
  }

  if (lines.length > 10000) {
    errors.push("Error: Number of rows should not exceed 10000");
  }

  if (errors.length > 0) {
    return errorFile(errors);
  }

  return "validated";

};

const validateForBulkUpdatePolygon = (lines, headers) => {
  const errors = [];

  const expectedHeaders = [
    "polygon_id",
    "is_active"
  ];

  // validate number of columns
  if (headers.length !== expectedHeaders.length) {
    errors.push("Error: Verify headers with sample file");
  } else {
    //validate headers names
    for (let i = 0; i < headers.length; i++) {
      if (headers[i] !== expectedHeaders[i]) {
        errors.push(`Error: Header mismatch at column ${i + 1}. Expected "${expectedHeaders[i]}", found "${headers[i]}"`);
      }
    }
  }

  if (lines.length > 10000) {
    errors.push("Error: Number of rows should not exceed 10000");
  }

  if (errors.length > 0) {
    return errorFile(errors);
  }

  return "validated";
};

// validate for CSV files uploaded on Notifications dashboard
const validateForDriverNotification = (lines, headers) => {
  const errors = [];

  // Empty file check
  if (lines.length == 0 || lines.length == 1) {
    errors.push(`Error: Empty CSV file.`);
  }

  // First column should be delivery_driver_id
  if (headers.length > 0 && headers[0] !== "delivery_driver_id") {
    errors.push(`Error: First column should be delivery_driver_id.`);
  }

  // Maximum of 10 headings allowed
  if (headers.length > 10) {
    errors.push(
      `Error: CSV file should have no more than 10 headings, found ${headers.length} headings.`
    );
  }

  //  No Empty Cells
  for (let i = 1; i < lines.length; i++) {
    const values = lines[i].split(",");
    const lineHasEntries = values.some((value) => value.trim() !== "");
    if (lineHasEntries) {
      // check only if line has entries (i.e. no validation for complete empty row)
      if (
        values.length !== headers.length ||
        values.some((value) => value.trim() === "")
      ) {
        errors.push(
          `Error: Line ${i + 1
          } has empty cells or does not match the number of headings.`
        );
      }
      if (values.length > 0 && values[0].slice(0, 2) == "FE") {
        errors.push(`Error: Line ${i + 1} has invalid delivery_driver_id.`);
      }
      for (let j = 0; j < values.length; j++) {
        if (values[j].length > 20) {
          errors.push(
            `Error: Line ${i + 1} and Column ${j + 1
            } consists of a variable of length more than 20 chars.`
          );
        }
      }
    }
  }

  // Limit of 1 Lakh entries per CSV
  if (lines.length > 100001) {
    errors.push("Error: CSV file should have a maximum of 100,000 entries.");
  }

  if (errors.length > 0) {
    const errorFileContent = errors.join("\n");
    const errorBlob = new Blob([errorFileContent], { type: "text/plain" });
    const errorFileUrl = URL.createObjectURL(errorBlob);

    const downloadLink = document.createElement("a");
    downloadLink.href = errorFileUrl;
    downloadLink.download = "error.txt";
    downloadLink.click();

    URL.revokeObjectURL(errorFileUrl);
    return "Please resolve errors mentioned in error.txt file";
  }

  return "validated";
};

// validate for CSV files uploaded on Notifications dashboard for Onboarding Applicants
const validateForDriverNotificationOB = (lines, headers) => {
  const errors = [];

  // Empty file check
  if (lines.length == 0 || lines.length == 1) {
    errors.push(`Error: Empty CSV file.`);
  }

  // First column should be ob_id
  if (headers.length > 0 && headers[0] !== "ob_id") {
    errors.push(`Error: First column should be ob_id.`);
  }

  // Maximum of 10 headings allowed
  if (headers.length > 10) {
    errors.push(
      `Error: CSV file should have no more than 10 headings, found ${headers.length} headings.`
    );
  }

  //  No Empty Cells
  for (let i = 1; i < lines.length; i++) {
    const values = lines[i].split(",");
    const lineHasEntries = values.some((value) => value.trim() !== "");
    if (lineHasEntries) {
      // check only if line has entries (i.e. no validation for complete empty row)
      if (
        values.length !== headers.length ||
        values.some((value) => value.trim() === "")
      ) {
        errors.push(
          `Error: Line ${i + 1
          } has empty cells or does not match the number of headings.`
        );
      }
      if (values.length > 0 && values[0].slice(0, 2) !== "OB") {
        errors.push(`Error: Line ${i + 1} has invalid ob_id.`);
      }
      for (let j = 0; j < values.length; j++) {
        if (values[j].length > 20) {
          errors.push(
            `Error: Line ${i + 1} and Column ${j + 1
            } consists of a variable of length more than 20 chars.`
          );
        }
      }
    }
  }

  // Limit of 1 Lakh entries per CSV
  if (lines.length > 100001) {
    errors.push("Error: CSV file should have a maximum of 100,000 entries.");
  }

  if (errors.length > 0) {
    const errorFileContent = errors.join("\n");
    const errorBlob = new Blob([errorFileContent], { type: "text/plain" });
    const errorFileUrl = URL.createObjectURL(errorBlob);

    const downloadLink = document.createElement("a");
    downloadLink.href = errorFileUrl;
    downloadLink.download = "error.txt";
    downloadLink.click();

    URL.revokeObjectURL(errorFileUrl);
    return "Please resolve errors mentioned in error.txt file";
  }

  return "validated";
};

const validateForDriverStories = (lines, headers) => {
  const errors = [];

  // Empty file check
  if (lines.length == 0 || lines.length == 1) {
    errors.push(`Error: Empty CSV file.`);
  }

  // First column should be entity_id
  if (headers.length > 0 && headers[0] !== "entity_id") {
    errors.push(`Error: First column should be entity_id.`);
  }

  //  No Empty Cells
  for (let i = 1; i < lines.length; i++) {
    const values = lines[i].split(",");
    const lineHasEntries = values.some((value) => value.trim() !== "");
    if (lineHasEntries) {
      // check only if line has entries (i.e. no validation for complete empty row)
      if (
        values.length !== headers.length ||
        values.some((value) => value.trim() === "")
      ) {
        errors.push(
          `Error: Line ${i + 1
          } has empty cells or does not match the number of headings.`
        );
      }
      if (values.length > 0 && values[0].slice(0, 2) === "FE") {
        errors.push(
          `Error: Line ${i + 1
          } has invalid driver Id. It should not start with FE`
        );
      }
      for (let j = 0; j < values.length; j++) {
        if (values[j].length > 20) {
          errors.push(
            `Error: Line ${i + 1} and Column ${j + 1
            } consists of a variable of length more than 20 chars.`
          );
        }
      }
    }
  }

  // Limit of 1 Lakh entries per CSV
  if (lines.length > 100001) {
    errors.push("Error: CSV file should have a maximum of 100,000 entries.");
  }

  if (errors.length > 0) {
    const errorFileContent = errors.join("\n");
    const errorBlob = new Blob([errorFileContent], { type: "text/plain" });
    const errorFileUrl = URL.createObjectURL(errorBlob);

    const downloadLink = document.createElement("a");
    downloadLink.href = errorFileUrl;
    downloadLink.download = "error.txt";
    downloadLink.click();

    URL.revokeObjectURL(errorFileUrl);
    return "Please resolve errors mentioned in error.txt file";
  }

  return "validated";
};

// validate for CSV files uploaded on communication hub dashboard
const validateForCommunicationHub = (lines, headers) => {
  const errors = [];

  // Empty file check
  if (lines.length == 0 || lines.length == 1) {
    errors.push(`Error: Empty CSV file.`);
  }

  // First column should be delivery_driver_id
  if (headers.length > 0 && headers[0] !== "entity_id") {
    errors.push(`Error: First column should be entity_id.`);
  }

  // Maximum of 1 headings allowed
  if (headers.length > 1) {
    errors.push(
      `Error: CSV file should have no more than 1 heading, found ${headers.length} headings.`
    );
  }

  //  FE prefix check
  for (let i = 1; i < lines.length; i++) {
    const values = lines[i].split(",");
    if (values.length > 0 && values[0].slice(0, 2) == "FE") {
      errors.push(`Error: Line ${i + 1} has invalid delivery_driver_id.`);
    }
  }

  // Limit of 1 Lakh entries per CSV
  if (lines.length > 100001) {
    errors.push("Error: CSV file should have a maximum of 100,000 entries.");
  }

  if (errors.length > 0) {
    const errorFileContent = errors.join("\n");
    const errorBlob = new Blob([errorFileContent], { type: "text/plain" });
    const errorFileUrl = URL.createObjectURL(errorBlob);

    const downloadLink = document.createElement("a");
    downloadLink.href = errorFileUrl;
    downloadLink.download = "error.txt";
    downloadLink.click();

    URL.revokeObjectURL(errorFileUrl);
    return "Please resolve errors mentioned in error.txt file";
  }

  return "validated";
};

// validate for CSV files uploaded on Notifications dashboard
const validateForFleetCoachTask = (lines, headers) => {
  const errors = [];

  const ExpectedHeaders = [
    "fleet_coach_id",
    "driver_id",
    "is_valid",
    "description",
  ];
  const ExpectedHeadersCount = ExpectedHeaders.length;
  const headerFields = 4;
  // Empty file check
  if (lines.length == 0 || lines.length == 1) {
    errors.push(`Error: Empty CSV file.`);
  }

  // Maximum of 4 headings allowed
  if (headers.length > ExpectedHeadersCount) {
    errors.push(
      `Error: CSV file should have no more than ${headerFields} headings, found ${ExpectedHeadersCount} headings.`
    );
  } else if (headers.length < ExpectedHeadersCount) {
    errors.push(
      `Error: CSV file should have ${headerFields} headings, found ${ExpectedHeadersCount} headings.`
    );
  } else if (JSON.stringify(headers) !== JSON.stringify(ExpectedHeaders)) {
    errors.push(
      `Error: CSV file has either invalid headers or headers are not in order`
    );
  }

  // Empty file check
  if (lines.length == 0 || lines.length == 1) {
    errors.push(`Error: Empty CSV file.`);
  }

  // Maximum of 4 headings allowed
  if (headers.length > ExpectedHeadersCount) {
    errors.push(
      `Error: CSV file should have no more than ${headerFields} headings, found ${ExpectedHeadersCount} headings.`
    );
  } else if (headers.length < ExpectedHeadersCount) {
    errors.push(
      `Error: CSV file should have ${headerFields} headings, found ${ExpectedHeadersCount} headings.`
    );
  } else if (JSON.stringify(headers) !== JSON.stringify(ExpectedHeaders)) {
    errors.push(
      `Error: CSV file has either invalid headers or headers are not in order`
    );
  }

  //  No Empty Cells
  for (let i = 1; i < lines.length; i++) {
    const values = lines[i].split(",");
    const lineHasEntries = values.some((value) => value.trim() !== "");
    if (lineHasEntries) {
      // check only if line has entries (i.e. no validation for complete empty row)
      for (let row = 0; row < values.length; row++) {
        if (row === 3) continue;
        if (values[row].trim().length === 0) {
          errors.push(
            `Error: Line ${i + 1} has empty ${ExpectedHeaders[row]} field`
          );
        }
      }

      for (let j = 0; j < values.length; j++) {
        if (values[j].length > 2000) {
          errors.push(
            `Error: Line ${i + 1} and Column ${j + 1
            } consists of a variable of length more than 2000 chars.`
          );
        }
      }
    }
  }

  if (lines.length > 100001) {
    errors.push("Error: CSV file should have a maximum of 100,000 entries.");
  }

  if (errors.length > 0) {
    const errorFileContent = errors.join("\n");
    const errorBlob = new Blob([errorFileContent], { type: "text/plain" });
    const errorFileUrl = URL.createObjectURL(errorBlob);

    const downloadLink = document.createElement("a");
    downloadLink.href = errorFileUrl;
    downloadLink.download = "error.txt";
    downloadLink.click();

    URL.revokeObjectURL(errorFileUrl);
    return "Please resolve errors mentioned in error.txt file";
  }
  return "validated";
};

// validate for CSV files uploaded on DriverProperties Bulk Upload dashboard
const validateForDriverProperties = (lines, headers, key) => {
  const errors = [];

  let ExpectedHeaders = ["driver_id"];
  let headerFields = 1
  if (key == "first_responder_training") {
    headerFields = 2
    ExpectedHeaders.push("date_of_training")
  }
  else if (key == "rider_helmet_address") {
    headerFields = 2
    ExpectedHeaders.push("helmet_address")
  }
  else if (key == "differently_abled") {
    headerFields = 2
    ExpectedHeaders.push("is_differently_abled")
  }
  const ExpectedHeadersCount = ExpectedHeaders.length;

  // Empty file check
  if (lines.length == 0 || lines.length == 1) {
    errors.push(`Error: Empty CSV file.`);
  }

  if (headers.length > ExpectedHeadersCount) {
    errors.push(
      `Error: CSV file should have no more than ${headerFields} headings, found ${ExpectedHeadersCount} headings.`
    );
  } else if (headers.length < ExpectedHeadersCount) {
    errors.push(
      `Error: CSV file should have ${headerFields} headings, found ${ExpectedHeadersCount} headings.`
    );
  } else if (JSON.stringify(headers) !== JSON.stringify(ExpectedHeaders)) {
    errors.push(
      `Error: CSV file has either invalid headers or headers are not in order`
    );
  }

  // Empty file check
  if (lines.length == 0 || lines.length == 1) {
    errors.push(`Error: Empty CSV file.`);
  }

  //  No Empty Cells
  for (let i = 1; i < lines.length; i++) {
    const values = lines[i].split(",");
    const lineHasEntries = values.some((value) => value.trim() !== "");
    if (lineHasEntries) {
      // check only if line has entries (i.e. no validation for complete empty row)
      for (let row = 0; row < values.length; row++) {
        if (row === 3) continue;
        if (values[row].trim().length === 0) {
          errors.push(
            `Error: Line ${i + 1} has empty ${ExpectedHeaders[row]} field`
          );
        }
      }

      if (values.length > 0 && isNaN(values[0])) {
        errors.push(`Error: Line ${i + 1} has invalid driver Id.`);
      }

      if (values.length > 0 && values[0].length > 1000000000) {
        errors.push(`Error: Line ${i + 1} has invalid driver Id length.`);
      }

      if (key == "first_responder_training" && isNaN(new Date(values[1]).getDate())) {
        errors.push(
          `Error: Line ${i + 1} has invalid date. It should be of given format`
        );
      }
      if (key == "differently_abled" && values[1] !== "true" && values[1] !== "false") {
        errors.push(
          `Error: Line ${i + 1} has invalid value. It should be either true or false`
        );
      }

      for (let j = 0; j < values.length; j++) {
        if (values[j].length > 20) {
          errors.push(
            `Error: Line ${i + 1} and Column ${j + 1
            } consists of a variable of length more than 20 chars.`
          );
        }
      }
    }
  }

  if (lines.length > 100001) {
    errors.push("Error: CSV file should have a maximum of 100,000 entries.");
  }

  if (errors.length > 0) {
    const errorFileContent = errors.join("\n");
    const errorBlob = new Blob([errorFileContent], { type: "text/plain" });
    const errorFileUrl = URL.createObjectURL(errorBlob);

    const downloadLink = document.createElement("a");
    downloadLink.href = errorFileUrl;
    downloadLink.download = "error.txt";
    downloadLink.click();

    URL.revokeObjectURL(errorFileUrl);
    return "Please resolve errors mentioned in error.txt file";
  }
  return "validated";
};

export default validateCSV;
